import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import Emergency from "./modules/bio/EmergencyForm";
import referee from "./modules/referee/referee";
import RefereeCard from "./modules/referee/refereeCard";
import profile from "./views/profile";

// contacts components
import contact from "./modules/contact/contact";
import ContactForm from "./modules/contact/ContactForm";

// academic components
import academic from "./modules/academic/academic";
import academicCard from "./modules/academic/academicCard";

// work experience components
import experience from "./modules/experience/experience";
import ExperienceCard from "./modules/experience/ExperienceCard";

// specialization components
import specialization from "./modules/specialization/specialization.vue";

import Auth from "../dashboard/modules/auth/middleware/Auth";
import AccountInfo from "./modules/account/AccountInfo";
import AdmissionLetter from "./modules/admission/AdmissionLetter";

export default [
  {
    path: "/profile",
    component: Dashboard,
    children: [
      {
        path: "",
        name: "profile",
        component: profile,
        children: [
          {
            path: "contact",
            name: "Contact",
            component: contact,
            meta: { middleware: [Auth] },
          },
          {
            path: "contact/card/:type",
            name: "ContactForm",
            component: ContactForm,
            meta: { middleware: [Auth] },
          },
          {
            path: "academic",
            name: "Academic",
            component: academic,
            meta: { middleware: [Auth] },
          },
          {
            path: "academic/card",
            name: "AcademicCard",
            component: academicCard,
            meta: { middleware: [Auth] },
          },
          {
            path: "experience",
            name: "Experience",
            component: experience,
            meta: { middleware: [Auth] },
          },
          {
            path: "experience/card",
            name: "ExperienceCard",
            component: ExperienceCard,
            meta: { middleware: [Auth] },
          },
          {
            path: "referee",
            name: "Referee",
            component: referee,
            meta: { middleware: [Auth] },
          },
          {
            path: "referee/card",
            name: "RefereeCard",
            component: RefereeCard,
            meta: { middleware: [Auth] },
          },
          {
            path: "specialization",
            name: "Specialization",
            component: specialization,
            meta: { middleware: [Auth] },
          },
          {
            path: "bio/emergency",
            name: "Emergency",
            component: Emergency,
            meta: { middleware: [Auth] },
          },
          {
            path: "account",
            name: "account",
            component: AccountInfo,
            meta: { middleware: [Auth] },
          },
          {
            path: "admission-letter",
            name: "AdmissionLetter",
            component: AdmissionLetter,
            meta: { middleware: [Auth] },
          },
        ],
      },
    ],
  },
];
